import React, { Children } from 'react'
import Link from 'gatsby-link'
import './Header.css'
import Modal from './Modal'

class Header extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      hasScrolled: false,
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  handleScroll = event => {
    const scrollTop = window.pageYOffset
    if (scrollTop > 50) {
      this.setState({ hasScrolled: true })
    } else {
      this.setState({ hasScrolled: false })
    }
  }

  render() {
    return (
      <div
        className={this.state.hasScrolled ? 'Header HeaderScrolled' : 'Header'}
      >
        <div className="HeaderGroup">
          <Link to="/">
            <img src={require('../images/arrow.svg')} width="30" />
          </Link>
          <a href="/whats-new">What's New</a>
          <a href="/pricing">Pricing</a>
          <button>
            <a href="https://geo.itunes.apple.com/us/app/the-views-news/id1322754821?mt=8">
              Download
            </a>
          </button>
        </div>
      </div>
    )
  }
}

export default Header
